export const MarketingCampaignsStatus = {
  REQUEST: 'MARKETING_CAMPAIGNS_REQUEST',
  SUCCESS: 'MARKETING_CAMPAIGNS_SUCCESS',
  ERROR: 'MARKETING_CAMPAIGNS_ERROR',
  RESET: 'MARKETING_CAMPAIGNS_RESET',
};
